import CostAllocationReducer from 'store/cost-allocation/reducers';

export { default as CostAllocationTypes } from 'store/cost-allocation/types';

export default CostAllocationReducer;
